import { INITIAL_SETTLEMENT } from '@/utils/constants';

export default function () {
  return {
    settlement: { ...INITIAL_SETTLEMENT },
    settlementLoading: false
  };
}
